import React from 'react';

export default function Disclaimer() {
  return (
    <footer 
      className="mt-auto pt-4 pb-3 px-4 text-center border-t border-zinc-100"
      data-testid="app-disclaimer"
    >
      <p className="text-[10px] leading-relaxed text-zinc-400 max-w-3xl mx-auto">
        All data, reports, and results provided through kaya.ai are presented as-is for informational purposes only. 
        kaya.ai assumes no responsibility for the accuracy, completeness, or suitability of any data or output. 
        Users are solely responsible for verifying all financial data, reports, and decisions. 
        Nothing herein constitutes financial, accounting, tax, or legal advice.
      </p>
    </footer>
  );
}
